import { render, staticRenderFns } from "./FileUploadManager.vue?vue&type=template&id=020637c8&scoped=true"
import script from "./FileUploadManager.vue?vue&type=script&lang=js"
export * from "./FileUploadManager.vue?vue&type=script&lang=js"
import style0 from "./FileUploadManager.vue?vue&type=style&index=0&id=020637c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020637c8",
  null
  
)

export default component.exports